import { Button, Popconfirm, Space, Table } from "antd";
import { EditFilled, DeleteFilled } from "@ant-design/icons";

const columnsUpdateHours = [
	{
		title: "Programación Web",
		dataIndex: "web",
		key: "web",
	},
	{
		title: "Programación Unity",
		dataIndex: "unity",
		key: "unity",
	},
	{
		title: "Diseño UI/UX",
		dataIndex: "desing",
		key: "desing",
	},
	{
		title: "Arte 3D",
		dataIndex: "art3d",
		key: "art3d",
	},
	{
		title: "Planeación",
		dataIndex: "planning",
		key: "planning",
	},
	{
		title: "Testing",
		dataIndex: "testing",
		key: "testing",
	},
];

const expandedRowRender = (record) => {
	const { beforeHours, afterHours, comment } = record;
	let newAfterHours = {};
	for (const key in afterHours) {
		if (Object.hasOwnProperty.call(afterHours, key)) {
			const elementAfter = afterHours[key];
			const elementBefore = beforeHours[key];
			newAfterHours[key] = elementAfter + elementBefore;
		}
	}
	let subDate = [
		{ key: 0, name: "Antes", ...beforeHours },
		{ key: 1, name: "Despues", ...newAfterHours },
	];
	const columns = [
		{
			title: "Info",
			dataIndex: "name",
			key: "name",
		},
		...columnsUpdateHours,
	];

	return (
		<Table
			columns={columns}
			dataSource={subDate}
			pagination={{
				position: ["none", "none"],
			}}
			summary={(pageData) => {
				return (
					<>
						<Table.Summary.Row>
							<Table.Summary.Cell index={0}>Comentario</Table.Summary.Cell>
							<Table.Summary.Cell index={1}>
								<span>{comment}</span>
							</Table.Summary.Cell>
						</Table.Summary.Row>
					</>
				);
			}}
		/>
	);
};

const propsColumnsUpdateHours = () => {
	return {
		size: "large",
		scroll: { x: "100vh", y: null },
		bordered: true,
		expandable: {
			expandedRowRender,
		},
	};
};

const columnsType = (editAction, deleteAction, total = 0, rols) => {
	return [
		{
			title: "Creado el",
			dataIndex: "createAt",
			key: "createAt",
		},
		...columnsUpdateHours,
		{
			title: "Moneda",
			dataIndex: "currency",
			key: "currency",
		},
		{
			title: "Horas",
			dataIndex: "amount",
			key: "amount",
		},
		{
			title: "Action",
			key: "action",
			render: (_, record, index) => {
				if (rols.isSuperAdmin && record.numberIndex === 0) {
					return (
						<Space size="middle">
							<Button
								type="text"
								icon={<EditFilled />}
								onClick={() => {
									editAction(record);
								}}
							/>
							<Popconfirm title="¿Seguro eliminar?" onConfirm={() => deleteAction(record.key)}>
								<Button type="text" icon={<DeleteFilled />} />
							</Popconfirm>
						</Space>
					);
				} else {
					return <></>;
				}
			},
		},
	];
};

export const columnsUpdateHoursProject = (editAction, deleteAction, total, rols) => {
	const columns = columnsType(editAction, deleteAction, total, rols);
	const props = propsColumnsUpdateHours();
	return { columns, props };
};
